import {Box, Typography} from '@material-ui/core'
import {makeStyles, Theme} from '@material-ui/core/styles'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {SplitLoadOrderIntakePayload} from '../../BulkCement/containers/SplitLoad/buildSplitLoadPayload'

const useStyles = makeStyles((theme: Theme) => ({
  materialItem: {
    padding: '8px 0',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  totalQuantity: {
    fontWeight: 'bold',
    marginTop: '8px'
  }
}))

interface MaterialsListProps {
  salesOrderLineItems: SplitLoadOrderIntakePayload['salesOrderLineItems']
  quantityUom: string
}

export const MaterialsList: React.FC<MaterialsListProps> = ({salesOrderLineItems, quantityUom}) => {
  const classes = useStyles()
  const {t} = useTranslation()

  const totalQuantity = salesOrderLineItems.reduce((sum, item) => sum + item.capacity.quantity, 0)

  return (
    <Box mb={2}>
      <Typography variant="body2" color="secondary" style={{marginBottom: '8px'}}>
        {t('orderIntake.materials')} ({salesOrderLineItems.length})
      </Typography>
      {salesOrderLineItems.map((lineItem, materialIndex) => (
        <Box key={`material-${materialIndex}`} className={classes.materialItem}>
          <Box display="flex" justifyContent="space-between" alignItems="start">
            <Box flex={1}>
              <Typography variant="body2" color="textPrimary">
                {lineItem.materialDescription || lineItem.materialNumber}
              </Typography>
            </Box>
            <Typography variant="body2" color="textPrimary" style={{fontWeight: 500}}>
              {lineItem.capacity.quantity} {quantityUom}
            </Typography>
          </Box>
        </Box>
      ))}

      <Box display="flex" justifyContent="space-between" className={classes.totalQuantity}>
        <Typography variant="body2" color="textPrimary">
          {t('orderIntake.splitLoad.total')}
        </Typography>
        <Typography variant="body2" color="textPrimary">
          {totalQuantity} {quantityUom}
        </Typography>
      </Box>
    </Box>
  )
}
